import {Text} from "@chakra-ui/react";
import * as React from "react";
import {useContext} from "react";
import {AppContext, AppContextI} from "../../components/context/ContextWrapper";

export const AreaTitle = () => {
    const appContext: AppContextI = useContext<AppContextI>(AppContext);
    const area = appContext.getArea();

    return (
        <Text fontWeight={"bold"} fontSize={"xl"}>
            {area?.name}
        </Text>
    );
}
